export enum ProjectAccessLevelValue {
	NONE = 'NONE',
	VIEWER = 'VIEWER',
	MANAGER = 'MANAGER',
	CUSTOM = 'CUSTOM',
}
